import dataCategories from '@services/categories';
import TopicGroup from '@templates/TopicGroup';
import { filterOnlyNeededDataPostGroup } from '@utils/postUtils';
import { getSliderBroker } from '@utils/sortBroker';
import { getCategoryBreadcrumbFromListCategory } from '@utils/wordpressUtil';
import { getLandingPageById } from 'cache-service/landingPage';
import { getAllForexBrokerDataCache } from 'cache-service/wpBrokerData';
import { getMostViewPostsCache } from 'cache-service/wpGroupPost';
import { getFeaturePostsCache } from 'cache-service/wpGroupPost';
import { getPostByCategories, getPostByWpIds } from 'cache-service/wpPost';
import { getPostInCategoriesAndSize } from 'cache-service/wpPost';
import React from 'react';

import { CATEGORY_SLUGS, PAGINATION } from '../Constants';
import { landingPagePosts } from './BrokerLandingPagePost';
const getPageNumber = (url = '') => {
  const urlSplit = url.split('/');
  if (urlSplit.length === 0) return null;
  const paramsIndex = urlSplit[urlSplit.length - 1].indexOf('?');
  if (paramsIndex != -1) {
    return parseInt(urlSplit[urlSplit.length - 1].substring(0, paramsIndex));
  }

  if (url.includes('/trang/')) {
    return urlSplit[urlSplit.length - 1];
  } else {
    return 1;
  }
};

export const getStaticProps = async (props) => {
  try {
    const { pageNextJs } = props;
    const landingPagesResp = await getLandingPageById(pageNextJs.originalId);
    const landingPages = landingPagesResp.data.content;
    const data = {
      acf: {
        description: landingPages.acf?.description || '',
        meta_title: landingPages.acf?.meta_title || '',
        path_page: landingPages.acf?.path_page || '',
      },
      title: landingPages.title || '',
    };

    //menu feature posts
    const featurePostGroups = await getFeaturePostsCache();
    const forexBrokersData = await getAllForexBrokerDataCache();
    const newSlickBrokers = getSliderBroker(forexBrokersData);

    //get posts
    let categorySplit = pageNextJs.url.split('/');
    if (categorySplit.includes('trang')) {
      categorySplit = categorySplit.slice(0, categorySplit.length - 2);
    }
    let posts = [];

    switch(categorySplit[0]) {
      case CATEGORY_SLUGS.REVIEW: {
        let postsCateReviewBroker = await getPostInCategoriesAndSize({
          categories: dataCategories.filter((category) => category.slug === CATEGORY_SLUGS.REVIEW).map((category) => category.id),
          size: 5000,
        });
        posts = filterOnlyNeededDataPostGroup(postsCateReviewBroker);
      }
        break;
      case 'review-megazine':
        {
          posts = landingPagePosts;
        }
        break;
      default:
        {
          const listPostOfCategorysResp = await getPostByCategories({
            categories: categorySplit,
            size: -1,
          });
          posts = listPostOfCategorysResp.data.content;
        }
    }

    //breadcrumb
    let breadcrumbPageCategory = categorySplit.map((item) => {
      const itemName = dataCategories.find((cate) => cate.slug === item);
      return {
        slug: item,
        name: itemName?.name,
      };
    });
    breadcrumbPageCategory = categorySplit[0] === 'review-megazine'
      ? [{ slug: 'review-megazine', name: 'Review Megazine' }]
      : getCategoryBreadcrumbFromListCategory(breadcrumbPageCategory);

    //paging
    const page = getPageNumber(pageNextJs.url);
    let index = page - 1;
    const postsPerPage = PAGINATION.PAGE_SIZE;
    const numberOfPages = Math.ceil(posts.length / postsPerPage);
    let postsOfCurrentPage = posts
      .sort((a, b) => b.date.localeCompare(a.date))
      .slice(index * postsPerPage, index * postsPerPage + postsPerPage)
      .map((post) => {
        return {
          id: post.id,
          excerpt: post.excerpt,
          slug: post.slug,
          title: post.title,
          date: post.date,
          author: post.author || null,
          last_modified: post.postModified || null,
          thumbnail: post.thumbnail || null,
        };
      });

    if (postsOfCurrentPage.length === 0 && index !== 0) throw 'error';

    const pageContext = {
      numberOfPages,
      currentPage: index + 1,
      posts: postsOfCurrentPage,
    };

    // most view posts
    const mostViewPostsRes = await getMostViewPostsCache();
    const mostViewPostsGroup = mostViewPostsRes[0].acf.group_posts
      .slice(0, 10)
      .filter((item) => item.post);
    const mostViewIds = mostViewPostsGroup.map((item) => item.post?.ID);
    let mostViewPosts = await getPostByWpIds(mostViewIds);

    const newMostViewPosts = mostViewPosts.map((p) => {
      const editedTitlePost = mostViewPostsGroup.find((item) => item.post?.ID == p.wpPostId);
      const manualTitle = { rendered: editedTitlePost.manual_title };

      return {
        id: p.id,
        title: manualTitle || null,
        date: p.date,
        excerpt: p.excerpt || null,
        thumbnail: p.thumbnail || null,
        slug: p.slug,
        author: p.author,
      };
    });

    return {
      props: {
        data: data,
        newSlickBrokers,
        pageContext,
        pageNextJs,
        newMostViewPosts,
        breadcrumbPageCategory,
        featurePostGroups,
      },
    };
  } catch (ex) {
    return {
      props: {},
      redirect: {
        destination: '/404',
        permanent: false,
      },
    };
  }
};

const Category = (props) => {
  return props.data ? <TopicGroup {...props} /> : <div />;
};

export default Category;
